// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"0e357937","824":"88af326f","954":"26a61135"}[chunkId] + ".chunk.css";
};